import { asyncLoad } from '@util'

const List = asyncLoad(() =>
  import('@components/LocalMerchant/NotificationManage')
)

export default {
  path: 'notificationManage',
  indexRoute: {
    component: List
  },
  stat: '通知管理'
}
